import ImagesFooterPaymentMethodsSvg from '@/public/images/footer/payment-methods.svg';

export { ImagesFooterPaymentMethodsSvg };
